import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy, CheckCircle2, XCircle, Sparkles } from "lucide-react";

export function FantaRecap({ nickname, refreshKey }) {
  const [data, setData] = useState(null);

  const load = useCallback(async (n) => {
    if (!n || n.trim().length < 2) { setData(null); return; }
    try {
      const r = await api.get("/fantapadel/recap", { params: { nickname: n.trim() } });
      setData(r.data.found ? r.data : null);
    } catch { setData(null); }
  }, []);

  useEffect(() => { load(nickname); }, [nickname, refreshKey, load]);

  if (!data) return null;

  const dateFmt = (() => {
    try { return new Date(data.date).toLocaleDateString("it-IT", { day: "numeric", month: "long" }); }
    catch { return ""; }
  })();

  return (
    <div className="ap-card p-5 border-emerald-500/20" data-testid="fanta-recap">
      <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-emerald-400" />
          <h3 className="font-display uppercase tracking-wide text-lg text-white">Com'è andato il tuo pronostico</h3>
        </div>
        <span className="text-xs text-slate-500">Giornata {data.matchday} · {dateFmt}</span>
      </div>

      <div className="flex items-center gap-4 mb-4">
        <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl bg-emerald-500/10 border border-emerald-500/30">
          <Trophy className="w-5 h-5 text-emerald-400" />
          <div>
            <div className="font-display font-black text-2xl text-emerald-400 leading-none">{data.points} <span className="text-sm text-slate-400">pt</span></div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-0.5">{data.correct}/{data.total} vincitori · {data.exact} esatti</div>
          </div>
        </div>
        <p className="text-sm text-slate-400 flex-1">
          {data.exact > 0 ? "Grande occhio! Hai azzeccato anche il punteggio esatto." : data.correct > 0 ? "Buon fiuto, continua così nella prossima giornata!" : "Giornata storta, rifatti al prossimo turno!"}
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-2">
        {data.matches.map((m) => {
          const winnerNames = m.pick_winner === "team1" ? m.team1 : m.team2;
          return (
            <div
              key={m.court}
              data-testid={`recap-court-${m.court}`}
              className={`rounded-lg px-2.5 py-2 border text-xs ${
                m.exact ? "border-emerald-500 bg-emerald-500/15"
                : m.winner_correct ? "border-emerald-500/40 bg-emerald-500/5"
                : "border-rose-500/30 bg-rose-500/5"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-[9px] uppercase tracking-wider text-slate-500">Campo {m.court}</span>
                {m.winner_correct ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400" /> : <XCircle className="w-3.5 h-3.5 text-rose-400" />}
              </div>
              <div className="text-slate-100 font-semibold truncate mt-0.5">{winnerNames.join(" / ")}</div>
              <div className="font-mono text-slate-400">Tu: {m.pick_score || "—"}</div>
              <div className="font-mono text-slate-500">Reale: {m.result_score}{m.exact && <span className="text-emerald-400"> ✓ esatto</span>}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
